// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".page__preview-evidence[data-v-7bd55e35]{display:flex;flex-direction:column;justify-content:center;align-items:center}.card-box[data-v-7bd55e35]{max-width:910px;margin:auto}.text__feedback-for-earner img[data-v-7bd55e35]{max-width:-moz-available;max-width:-webkit-fill-available}[data-v-7bd55e35] figure img,[data-v-7bd55e35] img.max-w-full{width:100%;height:auto}", ""]);
// Exports
module.exports = exports;
